import React from "react";
import {Card, Divider, Space, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslate} from "../../../hooks/translate.hook";
import {HealthCheckerIssueDetails} from "../../../models/health-checker/health-checker";
import {formatHealthCenterDateTime} from "../health-center.helpers";
import {HealthCenterIssueStatus} from "../tabs/issues/issues.status";
import {IssueUser} from "./issue.user";

const {Text} = Typography;

interface IssueAssignmentProps {
    issue: HealthCheckerIssueDetails;
}

export const IssueAssignment: React.FC<IssueAssignmentProps> = ({issue}) => {
    const t = useTranslate();

    return (
        <Card
            className="health-center-issue__card health-center-issue__assignment"
            title={(
                <Space>
                    <FontAwesomeIcon icon={["fas", "users"]} />
                    {t("HEALTH-CENTER.ISSUE.OWNERSHIP", {defaultValue: "Status and ownership"})}
                </Space>
            )}
        >
            <div className="health-center-issue__status-row">
                <Text type="secondary">{t("HEALTH-CENTER.ISSUE.STATUS", {defaultValue: "Status"})}</Text>
                <HealthCenterIssueStatus status={issue.status} className="health-center-issue__status" />
            </div>

            <Divider />
            <Text strong>{t("HEALTH-CENTER.ISSUE.ASSIGNED-TO", {defaultValue: "Assigned to"})}</Text>
            <div className="health-center-issue__users">
                {issue.assignedTo.length > 0
                    ? issue.assignedTo.map((user) => <IssueUser key={user.id} user={user} />)
                    : (
                        <Text type="secondary">
                            {t("HEALTH-CENTER.ISSUE.NOT-ASSIGNED", {defaultValue: "No assignees"})}
                        </Text>
                    )}
            </div>

            <Divider />
            <Text strong>{t("HEALTH-CENTER.ISSUE.RESOLUTION", {defaultValue: "Resolution"})}</Text>
            <div className="health-center-issue__resolution">
                {issue.resolvedBy ? (
                    <>
                        <IssueUser user={issue.resolvedBy} />
                        {issue.resolvedAt ? (
                            <Text type="secondary" className="health-center-issue__resolved-at">
                                <FontAwesomeIcon icon={["fas", "check-circle"]} />{" "}
                                {t("HEALTH-CENTER.ISSUE.RESOLVED-AT", {
                                    value: formatHealthCenterDateTime(issue.resolvedAt),
                                    defaultValue: "Resolved {{value}}",
                                })}
                            </Text>
                        ) : null}
                    </>
                ) : (
                    <Text type="secondary">
                        {t("HEALTH-CENTER.ISSUE.NOT-RESOLVED", {defaultValue: "Not resolved yet"})}
                    </Text>
                )}
            </div>
        </Card>
    );
};
